module.exports = "<button class=\"open-popup o-btn o-btn--text-shadow\" @click=\"openPopup()\" @keyup.enter=\"openPopup()\">\n\t{{ $t( translationString ) }}\n</button>"


//////////////////
// WEBPACK FOOTER
// ./assets/_js/components/open-popup/open-popup.vhtml
// module id = 308
// module chunks = 0